export const sliceNames = Object.freeze({
    LOGIN: "login",
    GLOBAL: "global",
});

export const UNLOADING_PALLETIZE_PALLET_MIN_WEIGHT = 840;
export const UNLOADING_PALLETIZE_PALLET_MAX_WEIGHT = 960;
export const WASHING_PALLETIZE_PALLET_MIN_WEIGHT = 900;
export const WASHING_PALLETIZE_PALLET_MAX_WEIGHT = 1200;
export const SORTING_PALLET_MAX_FRUIT_WEIGHT = 1300; // New
export const PALLET_GREEN_CASES = 30; // -> Done 
export const PALLET_ORANGE_CASES = 36; // -> Done
export const SORTING_MIN_WEIGHT_MAX_CASES = 1000; // -> Done
export const SORTING_MAX_PALLET_CASES = 36; // -> Done

export const EMPTY_PALLET_WEIGHT = 27; // -> Done
export const PLASTIC_EMPTY_PALLET_WEIGHT = 27;// -> Done
export const EMPTY_GREEN_CASE_WEIGHT = 2.13;// -> Done
export const EMPTY_ORANGE_CASE_WEIGHT = 2.13; // -> Done

export const GREEN_CASE_FRUIT_WEIGHT = 28; // -> done
export const ORANGE_CASE_FRUIT_WEIGHT = 25; // -> done
export const EXPECTED_RIPENING_DAYS = 3;
export const MAX_EVAPORATION_PRCNT_ALLOWED = 15; // -> Done
export const POUND_TO_KG =  0.453592;
export const PASTING_BOX_WEIGHT_IN_POUND =  20;
export const REF_ALLOWED_10LB_BOXES = 165; // -> Done
export const REF_ALLOWED_20LB_BOXES = 80; // -> Done
export const DEFAULT_TIMEZONE = "America/Mazatlan";
export const DEFAULT_DATE_FORMAT = "DD-MM-YYYY";
export const DEFAULT_TIME_FORMAT = "hh:mm A";
export const DEFAULT_DATETIME_FORMAT = "DD-MM-YYYY hh:mm A";
export const PROJECT_DATETIME_FORMAT = "DD-MM-YYYY hh:mm A";
export const PROJECT_DATE_FORMAT = "DD-MM-YYYY";
export const COOKING_EST_MINUTE_CHEEKS = 690; // New
export const COOKING_EST_MINUTE_STRIPS = 570; // New
export const REJECTED_KG_PER_CASE = 28;
export const MAX_TOTAL_PROCESSING_TRAY = 24;
export const MARGIN_FOR_REJECTED_KG = 0.01;
export const TOTAL_RIPENING_ROOM_CAPACITY = 540;
export const RIPENING_ROOM_CHART_TICK_INTERVAL = 100;
export const MAX_LIMIT_FOR_KG_BAGGED = 10000;
export const EMPTY_MESH_WEIGHT_KG = 1.8; // weight of one mesh/trey in KG -> (DONE)
export const PASTING_PACKING_BOX_WEIGHT_IN_KG = 11.34; // weight of one pasting packing box in KG (Done)



//  ########### Unloading ################
export const MARGIN_WEIGHT_FOR_UNLOADING_PALLET = 190;